module.exports = __webpack_public_path__ + "static/media/logoGrey.8ee55af3.svg";